export default {
	methods: {
		handleAPIError: function (err: any) {
			const that = this as any;
			if (!err.response) {
				that.openError(that.$t('snackbar.error'));
				return;
			}

			const { message, details } = err.response.data;
			if (message) {
				if (that.$te(`error_messages.${message}`)) {
					that.openError(that.$t(`error_messages.${message}`));
				}
				else {
					that.openError(message);
				}

			}
			else {
				that.openError(that.$t('snackbar.error'));
			}

			if (details) {
				return Object.keys(details).reduce((acc, k) => ({
					...acc,
					[k]: details[k].map((d: any) => that.$t(`validation.${d}`))
				}), {});
			}
			else {
				return {};
			}
		}
	}
};
